/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

// This part is to handle the showBy property
// showBy: <field>:<value>
// showBy: <field>
// Remark : same as in zeta-child.js, should move this to a common file
function isShowBy(app, data, showBy) {
  let _show = true;

  if (typeof showBy !== 'undefined') {
    if (typeof app[showBy] === 'boolean') {
      return app[showBy];
    }

    const criteria = showBy.split(':');
    const _fld = criteria[0];

    if (data[_fld]) {
      if (criteria.length > 1 && typeof data[_fld]==='string') {
        _show = (data[_fld].trim()!=='' 
          && data[_fld].match(new RegExp(criteria[1], 'i'))) ? true : false;
      } else {
        _show = (data[_fld]===true || `${data[_fld]}`.match(/1|A|Y/i)) ? true : false;
      }
    } else {
      _show = false;
    }
    
    if (criteria.length > 1 && criteria[1].match(/null|empty|false/i)) {
      _show = !data[_fld] || `${data[_fld]}`.trim()==='';
    }
  }

  return _show;
}

export function StaticSelect(props) {
  const { app, data, em } = props;
  let _show = isShowBy(app, data, em.showBy);

  // const { parentSize } = em;
  const parentSize = em.parentSize || (props.parent && props.parent.size) || 'half';
  const floating = em.floating;
  const groupClass = (floating ? '' : 'row') + ' ' + (em.class ? em.class : '');
  const labelClass = floating ? 'label mb-1' : `col-sm-${parentSize === 'full' ? '2' : '5'} col-form-label`;
  
  let isDisabled = em.readOnly;
  if (em.enableBy) {
    const criteria = em.enableBy.split(':');
    const _fld = criteria[0];

    if (data[_fld]) {
      if (criteria.length > 1) {
        isDisabled = data[_fld].match(new RegExp(criteria[1], 'i')) ? false : true;
      } else {
        isDisabled = (data[_fld]===true || data[_fld].match(/1|A|Y/i)) ? true : false;
      }
    }
  }

  if (em.disableBy) {
    const criteria = em.disableBy.split(':');
    const _fld = criteria[0];

    if (data[_fld]) {
      if (criteria.length > 1) {
        isDisabled = data[_fld].match(new RegExp(criteria[1], 'i')) ? true : false;
      } else {
        isDisabled = (data[_fld]===true || data[_fld].match(/1|A|Y/i)) ? true : false;
      }
    }
  }

  let inputClass = em?.label ? (floating ? '' : `col-sm-${parentSize === 'full' ? '10' : '7'}`) : `col-sm-12`;
  if (em?.inputClass) inputClass += ` ${em.inputClass}`;
  if (em?.size) inputClass += ` form-control-${em.size}`;

  const handleDefaultChange = useCallback((e) => {}, []);
  const handleChange = (em.onChange && app.handlers[em.onChange]) || props.onChange || handleDefaultChange;

  return (
    <div className={`form-group ${groupClass}`}>
      {_show && <>
        {em?.label && <label className={`${labelClass}`}>{em.label}</label>}
        <select
          className={`form-control ${inputClass}`}
          name={(em && em.field) || em.name}
          title={em.label || em.field}
          value={data && em.field && (data[em.field] || '')}
          onChange={handleChange} /* {props.onChange || handleDefaultChange} */
          disabled={isDisabled}
        >
          <option value="">---</option>
          {em.options &&
            em.options.map((t, i) => {
              return (
                <option key={i} value={t.value} disabled={t.disabled}>
                  {t.text}
                </option>
              );
            })}
        </select>
      </>}
    </div>
  );
}

StaticSelect.defaultProps = {
  em: {}, // { parentSize: 'half' },
};

StaticSelect.propTypes = {
  app : PropTypes.any, 
  em : PropTypes.any, 
  data: PropTypes.any,
  parent: PropTypes.any,
  onChange: PropTypes.func
}

export function ValidSelect(props) {
  const { app, data, em } = props;
  let _show = isShowBy(app, data, em.showBy);
  // const { parentSize } = em;
  const parentSize = em.parentSize || (props.parent && props.parent.size) || 'half';
  const floating = em.floating;
  const groupClass = (floating ? '' : 'row mr-1') + ' ' + (em.class ? em.class : '');
  const labelClass = floating ? 'label mb-1' : `col-sm-${parentSize === 'full' ? '2' : '5'} col-form-label`;
  const isDisabled = em.readOnly;

  // const inputClass = floating ? '' : `col-sm-${parentSize === 'full' ? '10' : '7'}`;
  let inputClass = em?.label ? (floating ? '' : `col-sm-${parentSize === 'full' ? '10' : '7'}`) : `col-sm-12`;
  if (em?.inputClass) inputClass += ` ${em.inputClass}`;
  if (em?.size) inputClass += ` form-control-${em.size}`;

  const handleDefaultChange = useCallback((e) => {}, []);
  const handleChange = (em.onChange && app.handlers[em.onChange]) || props.onChange || handleDefaultChange;

  return (
    <div className={`form-group ${groupClass}`}>
      {_show && <>
        <label className={`${labelClass}`}>{em.label}</label>
        <select
          className={`form-control ${inputClass}`}
          name={(em && em.field) || em.name}
          title={em.label || em.field}
          value={data && em.field && (data[em.field] || '')}
          onChange={handleChange} /* {props.onChange} */
          disabled={isDisabled}
        >
          <option value="">---</option>
          {em.options &&
            app[em.options] &&
            app[em.options].map((t, i) => {
              return (
                <option key={i} value={t.type_code || t.value} disabled={t.disabled}>
                  {t.type_desc || t.text}
                </option>
              );
            })}
        </select>
      </>}
    </div>
  );
}

ValidSelect.defaultProps = {
  em: {}, // parentSize: 'half'
  app: {},
};

ValidSelect.propTypes = {
  app : PropTypes.any, 
  em : PropTypes.any, 
  data: PropTypes.any,
  parent: PropTypes.any,
  onChange: PropTypes.func 
}